import {LogoutIcon} from "@components/icons";
import {translate} from "@util";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import {useThemeContext} from "@theme";

const LogoutDialog: React.FC<{
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}> = ({open, onConfirm, onCancel, loading = false}) => {
  const {theme} = useThemeContext();

  return (
    <Dialog open={open}>
      <Stack direction="row" mt={2} justifyContent="center">
        <Box
          sx={{
            bgcolor: theme.palette.secondary.dark,
            width: "64px",
            borderRadius: "32px",
            height: "64px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <LogoutIcon
            fontSize="large"
            sx={{
              color: theme.palette.getContrastText(
                theme.palette.secondary.dark,
              ),
            }}
          />
        </Box>
      </Stack>
      <DialogTitle align="center">
        {translate("userActions.logoutDialog.title")}
      </DialogTitle>
      <DialogContent>
        <Typography>{translate("userActions.logoutDialog.text")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary" disabled={loading}>
          {translate("userActions.logoutDialog.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          startIcon={<LogoutIcon />}
          color="error"
          disabled={loading}
          {...(loading && {sx: {position: "relative"}})}>
          {translate("userActions.logoutDialog.exit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export {LogoutDialog};
